import Contact from "../components/Contact";
const Contect = () =>{
    return <Contact/>
}
export default Contect;